import script from "./Lotes.vue?vue&type=script&setup=true&lang=js"
export * from "./Lotes.vue?vue&type=script&setup=true&lang=js"

import "./Lotes.vue?vue&type=style&index=0&id=3e583be4&lang=css"

const __exports__ = script;

export default __exports__